<template>
  <div
    class="d-flex align-center notification py-2 px-4"
    @click="(e) => lc_moveTo(e, item)"
  >
    <v-avatar size="48" class="mr-2">
      <img v-if="item.profile_image" :src="item.profile_image" />
      <img v-else src="/images/default-profile.jpg" />
    </v-avatar>
    <div>
      <small class="grey--text text--darken-2">{{
        moment(item.datetime.toDate()).format("DD-MMM-YYYY")
      }}</small
      ><br />
      <small v-if="item.type == 'connect'" class="ma-0 black--text"
        >{{ item.message }}
        <span class="font-weight-bold">{{ item.name }}</span></small
      >
      <small v-else-if="item.type == 'mention'" class="ma-0 black--text"
        >{{ item.name }}
        <span class="font-weight-bold">{{ item.message }}</span></small
      >
      <small v-else-if="item.type == 'group'" class="ma-0 black--text"
        ><span class="font-weight-bold">{{ item.name }}</span>
        {{ item.message }}
        <span class="font-weight-bold">{{ item.group }}</span></small
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "notification",
  props: ["item"],
  methods: {
    moment,
    lc_moveTo(e, item) {
      
      switch (item.type) {
        case "connect":
          this.$router.push("/profile/" + item.user);
          break;
        case "group":
          let isRequested = item.message.includes("requested");
          if (isRequested && item.for == this.authUser.id) {
            this.$router.push("/profile/" + item.user);
          } else {
            this.$router.push("/group/" + item.group_id);
          }
          break;
        case "mention":
          this.$router.push("/post/" + item.post_id);
          break;
      }
    },
  },
};
</script>

<style scoped>
.notification {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.notification:hover {
  background: rgba(0, 0, 0, 0.1);
}
</style>
